/* eslint-disable react/require-default-props */
import React, { useCallback, useEffect, useState } from 'react';
import { FiChevronLeft, FiChevronRight } from 'react-icons/fi';

import {
  StyledButton,
  StyledInput,
  StyledSelect,
} from '../../../../components';
import { Loading } from '../../../../components/Loading';
import { StatusModal } from '../../../../components/StatusModal';
import { StyledSelect2 } from '../../../../components/StyledSelect2';
import { useAuth } from '../../../../hooks/auth';
import { api } from '../../../../services/api';
import { useUserDocument } from '../../../../services/contexts/UserDocumentContext';
import { CnpjMask } from '../../../../utils/CnpjMask';
import { CpfMask } from '../../../../utils/CpfMask';
import { DocumentMask } from '../../../../utils/DocumentMask';
import { emailValidation } from '../../../../utils/EmailValidation';
import { User } from '../../pages';
import { PasswordForm } from '../PasswordForm';
import { Button, ButtonsContainer, Container, Form } from './styles';

interface IProps {
  setFormView: (value: boolean) => void;
  user?: User;
  setUser: (value: any) => void;
}

interface DocumentsType {
  label: string;
  value: string;
  __isNew__?: boolean;
}

const UserForm = ({ setFormView, user = {} as User, setUser }: IProps) => {
  const { handleNewDocuments } = useUserDocument();

  const { user: userLogged } = useAuth();

  const [email, setEmail] = useState('');
  const [emailError, setEmailError] = useState('');

  const [name, setName] = useState('');
  const [nameError, setNameError] = useState('');

  const [cnpj, setCnpj] = useState('');
  const [cnpjError, setCnpjError] = useState('');

  const [documents, setDocuments] = useState<Array<DocumentsType>>([]);

  const [phone, setPhone] = useState('');
  const [phoneError, setPhoneError] = useState('');

  const [profile, setProfile] = useState('');

  const [formReady, setFormReady] = useState(false);

  const [loading, setLoading] = useState(false);

  const [formMode, setFormMode] = useState<'Create' | 'Edit'>('Create');

  const [modal, setModal] = useState(false);
  const [modalMessage, setModalMessage] = useState('');
  const [modalType, setModalType] = useState<'success' | 'error'>('success');
  const [modalClosesForm, setModalClosesForm] = useState(false);

  const [handleChangePass, setHandleChangePass] = useState(false);

  const handleEmailInput = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      const { value } = e.currentTarget;

      const { message, status } = emailValidation({
        email: value,
        emptyEmail: 'Preenchimento obrigatório',
        incorrectEmail: 'Preenchimento incorreto',
      });

      if (status === 'notOk') {
        setEmailError(message);
      } else {
        setEmailError('');
      }

      setEmail(value);
    },
    []
  );

  const handleNameInput = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      const { value } = e.currentTarget;

      if (value.length === 0) {
        setNameError('Preenchimento obrigatório');
      } else if (value.length === 1) {
        setNameError('Preenchimento incorreto');
      } else {
        setNameError('');
      }

      setName(value);
    },
    []
  );

  // const handleCnpjInput = useCallback(
  //   (e: React.ChangeEvent<HTMLInputElement>) => {
  //     e.currentTarget.maxLength = 18;

  //     let { value } = e.currentTarget;

  //     value = value.replace(/\D/g, '');

  //     if (value.length <= 11) {
  //       const { message, status } = cpfValidation({
  //         cpf: value,
  //         emptyCpf: 'Preenchimento obrigatório',
  //         incorrectCpf: 'Preenchimento incorreto',
  //       });

  //       if (status === 'Error') {
  //         setCnpjError(message);
  //       } else {
  //         setCnpjError('');
  //       }

  //       setCnpj(CpfMask(value));
  //     }

  //     if (value.length > 11) {
  //       const { message, status } = cnpjValidation({
  //         cnpj: value,
  //         emptyCnpj: 'Preenchimento obrigatório',
  //         incorrectCnpj: 'Preenchimento incorreto',
  //       });

  //       if (status === 'notOk') {
  //         setCnpjError(message);
  //       } else {
  //         setCnpjError('');
  //       }

  //       setCnpj(CnpjMask(value));
  //     }
  //   },
  //   []
  // );

  const handlePhoneInput = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      e.currentTarget.maxLength = 15;
      let { value } = e.currentTarget;
      value = value.replace(/\D/g, '');
      if (value.length === 11) {
        value = value.replace(/^(\d{2})(\d{5})(\d{4})/, '($1) $2-$3');
      } else if (value.length === 10) {
        value = value.replace(/^(\d{2})(\d{4})(\d{4})/, '($1) $2-$3');
      }
      e.currentTarget.value = value;
      if (value.length > 0 && value.length < 14) {
        setPhoneError('Telefone incorreto');
      } else {
        setPhoneError('');
      }
      setPhone(value);
    },
    []
  );

  const handleProfileSelect = useCallback((profileValue: string) => {
    setProfile(profileValue);
  }, []);

  const handleSubmit = useCallback(
    async (e: React.FormEvent<HTMLFormElement>) => {
      e.preventDefault();
      if (!formReady || loading) {
        return;
      }

      const newDocuments = [...documents];

      const cnpj = documents[0].value.replace(/\D/g, '');

      const bodyDocuments = newDocuments
        .map(
          (document, index) => index !== 0 && document.value.replace(/\D/g, '')
        )
        .slice(1) as Array<string>;

      try {
        setLoading(true);
        const body = {
          cnpj,
          email,
          name,
          phone: `+55${phone}`,
          profile,
          documents: bodyDocuments,
        };

        let response;

        if (formMode === 'Create') {
          response = await api.post('/users/admin', body);
        } else {
          response = await api.put('/users', body);

          setUser({} as User);
          setFormMode('Create');
        }

        if (userLogged.id === user.id) {
          handleNewDocuments(cnpj, bodyDocuments);
        }

        if (formMode === 'Create' && response.data?.emailSent === false) {
          setModal(true);
          setModalType('error');
          setModalClosesForm(true);
          setModalMessage(
            'Usuário criado, mas o e-mail com a senha não foi enviado. Peça para o usuário usar a opção "Esqueci minha senha" na tela de login.'
          );
        } else {
          setFormView(false);
        }
      } catch (error: any) {
        const errorMessage =
          String(error?.response?.data?.message).toUpperCase().search('EMAIL') >
          -1
            ? 'Email não está disponível'
            : formMode === 'Create'
            ? 'Error ao realizar cadastro, tente novamente'
            : 'Error ao realizar atualização da informações do usuário, tente novamente';
        setModalClosesForm(false);
        setModal(true);
        setModalMessage(errorMessage);
        setModalType('error');
        console.error(error);
      } finally {
        setLoading(false);
      }
    },
    [
      formReady,
      loading,
      documents,
      email,
      name,
      phone,
      profile,
      formMode,
      setFormView,
      handleNewDocuments,
      setUser,
    ]
  );

  useEffect(() => {
    if (
      emailError === '' &&
      nameError === '' &&
      (documents.length === 0 || cnpjError === '') &&
      phoneError === '' &&
      email !== '' &&
      name !== '' &&
      (documents.length !== 0 || cnpj !== '') &&
      phone !== '' &&
      profile !== ''
    ) {
      setFormReady(true);
    } else {
      setFormReady(false);
    }
  }, [
    emailError,
    nameError,
    cnpjError,
    phoneError,
    email,
    name,
    cnpj,
    phone,
    profile,
    documents.length,
  ]);

  useEffect(() => {
    if (user.id) {
      setEmail(user.email);
      setCnpj(
        user.cnpj.length <= 11
          ? CpfMask(user.cnpj.padStart(11, '0'))
          : CnpjMask(user.cnpj)
      );
      setPhone(user.phone.substring(3, 99));
      setName(user.name);
      setProfile(user.profile);
      setFormMode('Edit');
    } else {
      setFormMode('Create');
    }
  }, [user]);

  const handleOnChangeDocuments = (values: any) => {
    const documents = values.map((value: any) => {
      let replaceValue = value.value.replace(/\D/g, '');

      replaceValue =
        replaceValue.length <= 14 ? replaceValue : replaceValue.substr(0, 14);

      return {
        ...value,
        value: replaceValue,
        label: DocumentMask(replaceValue),
      };
    });

    setDocuments(documents);
  };

  useEffect(() => {
    let documents: Array<string> = [];
    if (user.cnpj) {
      documents = [user.cnpj];
    }

    if (user.documents) {
      documents = [
        ...documents,
        ...user?.documents?.map((document) => document.document),
      ];
    }

    const documentsAsOptions = documents.map((document) => ({
      value: document,
      label: DocumentMask(document),
    }));

    setDocuments(documentsAsOptions);
  }, [user.cnpj, user.documents]);

  return (
    <>
      {modal && (
        <StatusModal
          setModal={(value) => {
            setModal(value);
            if (modalClosesForm) {
              setFormView(false);
            }
          }}
          text={modalMessage}
          type={modalType}
        />
      )}
      {loading && <Loading />}
      {!handleChangePass && user.id && userLogged.id === user.id && (
        <div>
          <StyledButton
            text="Alterar minha senha"
            icon={<FiChevronRight />}
            iconPosition="right"
            type="submit"
            color="#595044"
            iconWhiteBackground
            iconBorderRadius
            onClick={() => setHandleChangePass(true)}
          />
        </div>
      )}
      {!handleChangePass ? (
        <Form onSubmit={handleSubmit}>
          <Container>
            <>
              <StyledSelect2
                placeholder="Digite o CNPJ / CPF"
                setValues={handleOnChangeDocuments}
                value={documents}
              />
              <StyledInput
                placeholder="Digite o e-mail"
                sizeDisplay="md"
                value={email}
                onChange={handleEmailInput}
                error={!!emailError}
                errorMessage={emailError}
                disabled={formMode === 'Edit'}
              />
              <StyledInput
                placeholder="Digite o nome"
                sizeDisplay="md"
                value={name}
                onChange={handleNameInput}
                error={!!nameError}
                errorMessage={nameError}
              />
              <StyledInput
                placeholder="Digite o telefone"
                sizeDisplay="md"
                value={phone}
                onChange={handlePhoneInput}
                error={!!phoneError}
                errorMessage={phoneError}
              />
              <StyledSelect
                options={[
                  { id: 'admin', value: 'Admin' },
                  { id: 'usuario', value: 'Usuario' },
                ]}
                placeholder="Selecione o perfil"
                setValue={handleProfileSelect}
                sizeDisplay="md"
                value={profile}
              />{' '}
            </>
          </Container>

          <ButtonsContainer>
            <Button
              type="button"
              onClick={() => {
                if (user.id) {
                  setUser({} as User);
                }
                setFormView(false);
              }}
            >
              <FiChevronLeft />
              Cancelar
            </Button>
            <StyledButton
              text="Salvar"
              icon={<FiChevronRight />}
              iconPosition="right"
              type="submit"
              iconWhiteBackground
              iconBorderRadius
              disabled={!formReady}
            />
          </ButtonsContainer>
        </Form>
      ) : (
        <PasswordForm onClose={() => setHandleChangePass(false)} />
      )}
    </>
  );
};

export { UserForm };
